import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppRoutes from "./route/AppRoutes";
import PrivacyPolicy from "./privacy/PrivacyPolicy";
import TermsAndConditions from "./privacy/TermsAndConditions";
import Faq from "./privacy/Faq";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-Conditions" element={<TermsAndConditions />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/*" element={<AppRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;